export const DEFAULT_ICON = "/images/defaultIcon.png";